<template>
  <div>
    <b-row>
      <b-col
          md="6"
          xl="6"
          style="margin-top: -1em"
      >
        <div class="p-1" style="background-color: #292f46;border-radius: 0.5em">
          <b-tabs pills>
            <b-tab fill title="Abholadresse" active>

              <b-row>
                <b-col
                    md="4"
                    xl="4"
                >
                  <b-form-group
                      label="Postleitzahl"
                      label-for="ZipCode"
                  >
                    <b-form-input
                        id="ZipCode"
                        v-model="vData.PickUpAddress.ZipCode"
                        size="sm"
                        tabindex="3"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                    md="4"
                    xl="4"
                >
                  <b-form-group
                      label="Ort"
                      label-for="Location"
                  >
                    <b-form-input
                        id="Location"
                        v-model="vData.PickUpAddress.Location"
                        size="sm"
                        tabindex="4"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                    md="4"
                    xl="4"
                >
                  <b-form-group
                      label="Ortsteil"
                      label-for="District"
                  >
                    <b-form-input
                        id="District"
                        v-model="vData.PickUpAddress.District"
                        size="sm"
                        tabindex="5"
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col
                    md="9"
                    xl="9"
                >
                  <b-form-group
                      label="Adresse"
                  >
                    <b-form-input
                        @keyup="OpenPopover('pickupStreet')"
                        id="PickupAddressData-Street-popoverShow"
                        @blur.stop="ClosePopoverStreet()"
                        v-model="vData.PickUpAddress.Street"
                        ref="PickupAddressStreet"
                        size="sm"
                        tabindex="6"
                    />
                  </b-form-group>
                </b-col>

                <b-col
                    md="3"
                    xl="3"
                >
                  <b-form-group
                      label="."
                  >
                    <b-button
                    class="btn-sm"
                      @click="SelectAddress(0, 'pickup')">
                      Flughafen (LEJ)
                    </b-button>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </div>
        <div id="pickupAddress">
        </div>
        <div id="pickupInfo">
        </div>
      </b-col>
      <b-col
          md="6"
          xl="6"
          style="margin-top: -1em"
      >

        <div class="p-1 " style="background-color: #292f46;border-radius: 0.5em">
          <b-tabs pills>
            <b-tab fill title="Zieladresse" active>
              <b-row>
                <b-col
                    md="4"
                    xl="4"
                >
                  <b-form-group
                      label="Postleitzahl"
                      label-for="ZipCode"
                  >
                    <b-form-input
                        id="ZipCode"
                        v-model="vData.DestinationAddress.ZipCode"
                        size="sm"
                        tabindex="12"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                    md="4"
                    xl="4"
                >
                  <b-form-group
                      label="Ort"
                      label-for="Location"
                  >
                    <b-form-input
                        id="Location"
                        v-model="vData.DestinationAddress.Location"
                        size="sm"
                        tabindex="13"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                    md="4"
                    xl="4"
                >
                  <b-form-group
                      label="Ortsteil"
                      label-for="District"
                  >
                    <b-form-input
                        id="District"
                        v-model="vData.DestinationAddress.District"
                        size="sm"
                        tabindex="14"
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col
                    md="9"
                    xl="9"
                >
                  <b-form-group
                      label="Adresse"
                  >
                    <b-form-input
                        @keyup="OpenPopover('destinationStreet')"
                        id="DestinationAddressData-Street-popoverShow"
                        @blur.stop="ClosePopoverStreet()"
                        v-model="vData.DestinationAddress.Street"
                        ref="DestinationAddressStreet"
                        size="sm"
                        tabindex="15"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                    md="3"
                    xl="3"
                >
                  <b-form-group
                      label="."
                  >
                    <b-button
                        class="btn-sm"
                        @click="SelectAddress(0, 'destination')">
                      Flughafen (LEJ)
                    </b-button>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col
          md="6"
          xl="6"
          style="margin-top: 1em"
      >
        <b-card-code>
          <b-row>
            <b-col
                md="6"
                xl="6"
            >
              <b-form-group
                  label="Name bzw Anrede"
                  label-for="name"
              >
                <b-form-input
                    id="Name"
                    v-model="vData.Name"
                    size="sm"
                    tabindex="3"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col
                md="6"
                xl="6"
            >
              <b-form-group
                  label="E-Mail Adresse"
                  label-for="email"
              >
                <b-form-input
                    id="email"
                    v-model="vData.Email"
                    size="sm"
                    tabindex="3"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>

          </b-row>
        </b-card-code>

      </b-col>
      <b-col
          md="6"
          xl="6"
          style="margin-top: 1em"
      >

        <b-card-code title="Zahlungsinfomation">
          <h4>Entfernung: {{ new Intl.NumberFormat().format(this.vData.TripRoute.TripDistanceMeter) }}km<br></h4>
          <hr>
          <h4>Fahrzeit (Mit Fahrgast): ca. {{ parseInt(this.vData.TripRoute.TripDuration / 60) }} Minuten ({{ (parseInt(this.vData.TripRoute.TripDuration / 60) / 60).toFixed(2) }}h)</h4>
          <h4>Fahrzeit: ca. {{ parseInt(this.vData.TripRoute.TripFullDuration / 60) }} Minuten ({{ (parseInt(this.vData.TripRoute.TripFullDuration / 60) / 60).toFixed(2) }}h)</h4>
          <hr>
          <h4>Taxipreis 1-3 Personen: ca. {{ this.$options.filters.currency(this.vData.Taxipreis) }}</h4>
          <h4>Taxipreis 4-8 Personen: ca. {{ this.$options.filters.currency(this.vData.Taxipreis2) }}</h4>
          <hr>
          <h4>Unser Preis 1-3 Personen: {{ this.$options.filters.currency(this.vData.Price) }}</h4>
          <h4>Unser Preis 4-8 Personen: {{ this.$options.filters.currency(this.vData.Price2) }}</h4>

          <b-row>
            <b-col
                md="5"
                xl="5"
                style="margin-top: 2.3em"
            >
              <b-button
                  class="col-12"
                  :variant="hasErrors ? 'info' : 'success'"
                  @click="LoadCustomer()"
              >
                <span v-show="!loading.base"> Angebot berechnen  </span>
                <!-- IF YOU ARE USING VUE BOOTSTRAP USE <b-spinner label="Loading..."></b-spinner> -->
                <div
                    v-show="loading.base"
                    class="spinner-border spinner-border-sm"
                    role="status"
                >
                  <span class="sr-only">Loading...</span>
                </div>
              </b-button>


            </b-col>
            <b-col
                md="2"
                xl="2"
                style="margin-top: 2.3em"
            >

            </b-col>
            <b-col
                md="5"
                xl="5"
                style="margin-top: 2.3em"
            >
              <b-button
                  class="col-12"
                  v-show="vData.Price > 0 && vData.Email != ''"
                  :variant="'success'"
                  @click="SendOffer"
              >
                <span v-show="!loading.base"> Angebot versenden  </span>
                <!-- IF YOU ARE USING VUE BOOTSTRAP USE <b-spinner label="Loading..."></b-spinner> -->
                <div
                    v-show="loading.base"
                    class="spinner-border spinner-border-sm"
                    role="status"
                >
                  <span class="sr-only">Loading...</span>
                </div>
              </b-button>

            </b-col>
          </b-row>
        </b-card-code>
      </b-col>
    </b-row>
    <b-popover
        ref="popover"
        :target="PickupAddressData.popover.street.target"
        :show.sync="PickupAddressData.popover.street.show"
        :disabled.sync="PickupAddressData.popover.street.disabled"
        placement="bottom"
        container="my-container"
    >
      <template v-slot:title>
        <div class="d-flex justify-content-between align-items-center">
          <span>Adresssuche</span>
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              class="close"
              variant="transparent"
              aria-label="Close"
          >
            <span
                class="d-inline-block text-white"
                aria-hidden="true"
            >&times;</span>
          </b-button>
        </div>
      </template>

      <div>
        <b-table responsive="xl"
                 class="row-pointer"
                 :items="PickupAddressData.popover.street.searchList"
                 :fields="PickupAddressData.popover.street.fields"
                 @row-clicked="SelectAddressBySearch"
        />
      </div>
    </b-popover>

    <b-popover
        ref="popover"
        target="PickupAddressData-popoverShow"
        :show.sync="PickupAddressData.popoverShow"
        :disabled.sync="PickupAddressData.popoverDisabled"
        placement="bottom"
        container="my-container"
    >
      <template v-slot:title>
        <div class="d-flex justify-content-between align-items-center">
          <span>Adresssuche</span>
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              class="close"
              variant="transparent"
              aria-label="Close"
          >
            <span
                class="d-inline-block text-white"
                aria-hidden="true"
            >&times;</span>
          </b-button>
        </div>
      </template>

      <div>
        <b-table responsive="xl"
                 class="row-pointer"
                 :items="PickupAddressData.filteredOptions"
                 :fields="AddressSearchData.fields"
                 @row-clicked="SelectPickupAddressByName"
        />
      </div>
    </b-popover>
    <b-popover
        ref="popover"
        target="DestinationAddressData-popoverShow"
        :show.sync="DestinationAddressData.popoverShow"
        :disabled.sync="DestinationAddressData.popoverDisabled"
        placement="bottom"
        container="my-container"
    >
      <template v-slot:title>
        <div class="d-flex justify-content-between align-items-center">
          <span>Adresssuche</span>
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              class="close"
              variant="transparent"
              aria-label="Close"
          >
            <span
                class="d-inline-block text-white"
                aria-hidden="true"
            >&times;</span>
          </b-button>
        </div>
      </template>

      <div>

        <b-table responsive="xl"
                 class="row-pointer"
                 :items="DestinationAddressData.filteredOptions"
                 :fields="AddressSearchData.fields"
                 @row-clicked="SelectDestinationAddressByName"
        />
      </div>
    </b-popover>

    <b-popover
        ref="popover"
        target="Customer-popoverShow"
        :show.sync="CustomerPopover.popover.popoverShow"
        :disabled.sync="CustomerPopover.popover.disabled"
        placement="bottom"
        container="my-container"
    >
      <template v-slot:title>
        <div class="d-flex justify-content-between align-items-center">
          <span>Kundensuche</span>
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              class="close"
              variant="transparent"
              aria-label="Close"
              @click="ClosePopoverCustomerSearch"
          >
            <span
                class="d-inline-block text-white"
                aria-hidden="true"
            >&times;</span>
          </b-button>
        </div>
      </template>

      <div>
        <b-table responsive="xl"
                 class="row-pointer"
                 :items="CustomerPopover.popover.searchList"
                 :fields="CustomerPopover.popover.fields"
                 @row-clicked="SelectCustomerBySearch"
        >
          <template #cell(Name)="data">
            {{ data.item.Name }} {{ data.item.Contact.Name }}
          </template>
        </b-table>
      </div>
    </b-popover>

  </div>
</template>

<script>
import Remark from '@/views/voucher/Remark'
import EuroField from '@/views/voucher2/EuroFild.vue'
import Cleave from 'vue-cleave-component'
import BCardCode from '@core/components/b-card-code'
import {
  BAlert,
  BTable,
  BFormCheckbox,
  BBadge,
  BFormSelect,
  BButton,
  BCol,
  BFormGroup,
  BFormInput,
  BRow,
  BDropdown,
  BDropdownDivider,
  BDropdownForm,
  BDropdownGroup,
  BDropdownItem,
  BPopover,
  BTab,
  BTabs,
  BInputGroupPrepend,
  BInputGroupAppend,
  VBTooltip, BInputGroup, BSpinner, BFormDatepicker
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { VueAutosuggest } from 'vue-autosuggest'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import price from '../administration/Price.vue'

export default {
  name: 'VoucherMask',
  computed: {
    price() {
      return price
    }
  },
  components: {
    BAlert,
    BFormCheckbox,
    BTab,
    BTabs,
    EuroField,
    BFormSelect,
    Cleave,
    BTable,
    Remark,
    BCardCode,
    VueAutosuggest,
    BPopover,
    BDropdown,
    BDropdownDivider,
    BDropdownForm,
    BDropdownGroup,
    BDropdownItem,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BRow,
    BCol,
    BButton,
    BBadge,
    BInputGroupPrepend,
    BInputGroupAppend,
    BSpinner,
    BFormDatepicker
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {

      R515: false,

      PickupMapShow: false,
      showInfo: true,
      blockCode: '',
      loading: {
        base: false,
        price: false,
        openPdf: false,
      },
      timeout: {
        EuroLoading: null
      },
      zoneName: '',
      AddressSearchData: {
        autoSuggestLimit: 8,
        fields: [
          {
            key: 'AddressId',
            label: 'Kennung',
          },
          {
            key: 'Address.Street',
            label: 'Adresse',
          },
          {
            key: 'Address.Location',
            label: 'Ort',
          },
          {
            key: 'Contact.Name',
            label: 'Name',
          },
          {
            key: 'Contact.Phone',
            label: 'Telefon',
          },
        ],
      },
      SaveButton: null,
      hasErrors: true,
      VatRateLabel: '',
      EndSum: '',
      IsCrewTrip: false,
      options: {
        Time2Label: 'Abflug',
        date: {
          date: true,
          delimiter: '.',
          datePattern: ['d', 'm', 'y'],
        },
        time: {
          time: true,
          timePattern: ['h', 'm'],
        },
        number: {
          numericOnly: true,
          blocks: [16],
          delimiters: ['']
        },

      },
      CustomerPopover: {
        popover: {
          target: 'Customer-popoverShow',
          popoverShow: false,
          disabled: false,
          timeout: null,
          searchList: [],
          lastInput: '',
          fields: [
            {
              key: 'CustomerNumber',
              label: 'Kundennummer',
            },
            {
              key: 'Name',
              label: 'Name',
            },
            {
              key: 'Address.Street',
              label: 'Straße',
            },
            {
              key: 'Address.ZipCode',
              label: 'Plz',
            },
            {
              key: 'Address.Location',
              label: 'Ort',
            },
          ],
        },
      },
      PickupAddressData: {
        filteredOptions: [],
        selected: null,
        popoverShow: false,
        popoverDisabled: true,
        popover: {
          street: {
            target: 'PickupAddressData-Street-popoverShow',
            show: false,
            disabled: false,
            timeout: null,
            searchList: [],
            lastInput: '',
            fields: [
              {
                key: 'Address',
                label: 'Adresse',
              },
              {
                key: 'DistanceMeters',
                label: 'Entfernung',
              },
            ],
          }
        },
      },
      DestinationAddressData: {
        filteredOptions: [],
        autoSuggestLimit: 60,
        selected: null,
        popoverShow: false,
        popoverDisabled: true,
      },
      Equipment: {
        value: {
          IdentId: 0,
          Price: 0,
          Name: '',
        },
        text: '',
      },
      EquipmentPrice: 0,
      EquipmentList: [],
      TransportTicketList: [
        {
          value: false,
          text: 'Nein',
        },
        {
          value: null,
          text: '',
        },
        {
          value: true,
          text: 'Ja',
        }
      ],
      AdditionalPaymentList: [
        {
          value: false,
          text: 'Nein',
        },
        {
          value: null,
          text: '',
        },
        {
          value: true,
          text: 'Ja',
        }
      ],
      Customer: {
        IdentId: 0,
        Number: '',
        Name: ''
      },
      tempId: 0,
      vData: {
        TripRoute: {
          TripDistanceMeter: 0,
          TripFullDistanceMeter: 0,
          TripDuration: 0,
          TripFullDuration: 0,
        },
        Taxipreis: 0,
        Price: 0,
        Email: "",
        Name: "Sehr geehrte Damen und Herren,",
        Taxipreis2: 0,
        Price2: 0,
        Customer: 0,
        PickUpPassengerIdentId: 0,
        PickUpPassengerNumber: '',
        DestinationPassengerIdentId: 0,
        DestinationPassengerNumber: '',
        PickUpAddress: {
          Street: '',
          ZipCode: '',
          Location: '',
          District: '',
        },
        DestinationAddress: {
          Street: '',
          ZipCode: '',
          Location: '',
          District: '',
        },
      },
    }
  },
  mounted() {
    let i = this

    this.$nextTick(() => {
      document.title = 'V: ' + this.$route.params.id
      this.HasUserDeleteRight()
    })
    ConvertTravelDate: {
      let d = new Date()
      let ye = new Intl.DateTimeFormat('de', { year: '2-digit' }).format(d)
      let mo = new Intl.DateTimeFormat('de', { month: '2-digit' }).format(d)
      let da = new Intl.DateTimeFormat('de', { day: '2-digit' }).format(d)
      this.vData.TravelDay = `${da}.${mo}.${ye}`
    }
    Load: {
      this.blockCode = this.MakeBlockCode(24)

      this.ChangeRideType(0)
      if (this.LoadEquipmentList()) {
        this.LoadVoucher()
      }
    }
    this.$nextTick(() => this.$refs.PickUpPassengerNumber.$el.select())
    this.Watch()
    EnterEvent: {
      window.addEventListener('keydown', function (event) {
        // If down arrow was pressed...
        if (event.key == 'Enter') {
          if (this.hasErrors == false) {
          }

        }
      }.bind(this), false)
    }
  },
  methods: {

    formatDate(date) {
      return data.toLocaleDateString()
    },
    setLoadingBar() {
      console.log('TEST')
      this.loading.base = true
      clearTimeout(this.timeout.EuroLoading)
      this.timeout.EuroLoading = setTimeout(() => {
        this.loading.base = false
      }, 500)
    },
    Audio(name) {
      let audio = new Audio(require('@/assets/audio/' + name))
      audio.play()
    },
    MakeBlockCode(length) {
      let result = ''
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      const charactersLength = characters.length
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength))
      }
      return result
    },

    onDateFromContext(ctx) {
      if (ctx.selectedDate) {
        // The date formatted in the locale, or the `label-no - date - selected` string
        this.formatted = ctx.selectedFormatted
        // The following will be an empty string until a valid date is entered
        this.selected = ctx.selectedYMD
        this.vData.TravelDay = ctx.activeFormatted
        this.NextInput('TravelDay')
      }
    },
    onDateFromReturnContext(ctx) {
      if (ctx.selectedDate) {
        // The date formatted in the locale, or the `label-no - date - selected` string
        this.formatted = ctx.selectedFormatted
        // The following will be an empty string until a valid date is entered
        this.selected = ctx.selectedYMD
        this.returnTripData.TravelDay = ctx.activeFormatted
        this.NextInput('ReturnTravelDay')
      }
    },
    NumberOnlyAndAddDay(ev) {
      const isNumber = /^[0-9]$/i.test(ev.key)
      if (ev.key == '+' || ev.key == '-') {
        const date = this.vData.TravelDay.split('.')
        if (date[0].length == 2 && date[1].length == 2 && date[2].length == 2) {
          let TravelDay = new Date('20' + date[2] + '-' + date[1] + '-' + date[0])
          if (ev.key == '+') {
            TravelDay.setDate(TravelDay.getDate() + 1)
          }
          if (ev.key == '-') {
            TravelDay.setDate(TravelDay.getDate() - 1)
          }

          this.vData.TravelDay = new Date(TravelDay).toLocaleString('de-DE', {
                year: '2-digit',
                month: '2-digit',
                day: '2-digit'
              },
          )
          this.TravelDayName = new Date(TravelDay).toLocaleString('de-DE', {
                weekday: 'long',
              },
          ) + ','

        }
      }
      return false
    },
    NumberOnlyAndAddDay2(ev) {
      const isNumber = /^[0-9]$/i.test(ev.key)
      if (ev.key == '+' || ev.key == '-') {
        const date = this.returnTripData.TravelDay.split('.')
        if (date[0].length == 2 && date[1].length == 2 && date[2].length == 2) {
          let TravelDay = new Date('20' + date[2] + '-' + date[1] + '-' + date[0])
          if (ev.key == '+') {
            TravelDay.setDate(TravelDay.getDate() + 1)
          }
          if (ev.key == '-') {
            TravelDay.setDate(TravelDay.getDate() - 1)
          }

          this.returnTripData.TravelDay = new Date(TravelDay).toLocaleString('de-DE', {
                year: '2-digit',
                month: '2-digit',
                day: '2-digit'
              },
          )
          this.ReturnTravelDayName = new Date(TravelDay).toLocaleString('de-DE', {
                weekday: 'long',
              },
          ) + ','

        }
      }
      return false
    },
    FormatTravelDay() {
      const date = this.vData.TravelDay.split('.')
      let TravelDay = new Date('20' + date[2] + '-' + date[1] + '-' + date[0])
      this.vData.TravelDay = new Date(TravelDay).toLocaleString('de-DE', {
            year: '2-digit',
            month: '2-digit',
            day: '2-digit'
          },
      )
      this.TravelDayName = new Date(TravelDay).toLocaleString('de-DE', {
            weekday: 'long',
          },
      ) + ','

      this.returnTripData.TravelDay = new Date(TravelDay).toLocaleString('de-DE', {
            year: '2-digit',
            month: '2-digit',
            day: '2-digit'
          },
      )
      this.ReturnTravelDayName = new Date(TravelDay).toLocaleString('de-DE', {
            weekday: 'long',
          },
      ) + ','
    },
    ChangeRideType(type) {
      this.vData.RideType = type

      if (this.vData.RideType == 99) {
        this.vData.RideType = 0
        this.IsCrewTrip = true
        localStorage.lastVoucher_IsCrewTrip = true
      }

      if (this.vData.RideType == 88) {
        if (localStorage.lastVoucher == undefined) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Es gibt keine letzte eingabe',
              icon: 'EditIcon',
              variant: 'error',
            },
          })
          this.RouterBack()
          return
        }

        this.vData = JSON.parse(localStorage.lastVoucher)
        this.vData.Vid = 0
        setTimeout(() => {
          this.$nextTick(() => {

            this.$http.get(`/customer/customerId/${this.vData.Customer}`)
                .then(resp => {
                  this.Customer.Name = resp.data.Name
                  this.Customer.Number = resp.data.CustomerNumber
                  this.Customer.IdentId = this.vData.Customer
                  this.LoadCustomer()
                })
                .catch(err => {
                  console.error(err)
                })

            this.$nextTick(() => this.$refs.TravelDay.$el.select())
            this.IsCrewTrip = localStorage.lastVoucher_IsCrewTrip
          })
        }, 500)
      }
      localStorage.lastVoucher_RideType = this.vData.RideType
      if (this.vData.RideType == 2) {
        this.options.Time2Label = 'Wunsch Ank.'
      }
      if (this.vData.RideType == 1) {
        this.options.Time2Label = 'Terminzeit'
      }
      if (this.vData.RideType == 0) {
        this.options.Time2Label = 'Abflug'
      }
    },
    PriceCheck() {
      this.$swal({
        title: 'Preis Check',
        text: 'Soll der Fahrpreis neu berechnet werden?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ja',
        cancelButtonText: 'Nein, überspringen',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
          .then(result => {
            if (result.isConfirmed) {
              this.GetPrice()
              this.SelectInput('DescriptionInvoice')
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Abbruch',
                  icon: 'CheckIcon',
                  text: 'Vorgang abgebrochen.',
                  variant: 'warning',
                },
              })
            }
          })
    },
    async GetPrice() {
      this.loading.price = true
      await this.CalculatePrice()
      this.loading.price = false
    },
    Watch() {
      console.log('Start Watch')
      this.$watch(
          () => this.$refs.EuroFieldPrice.watch,
          val => {
            this.CalculateVat()
            this.$refs.EuroFieldExtraPrice.Focus()
          },
      )

      this.$watch(
          () => document.activeElement,
          val => {
            console.log(document.activeElement)
          },
      )
      this.$watch(
          () => this.$refs.EuroFieldExtraPrice.watch,
          val => {
            this.CalculateVat()
            this.$refs.DescriptionInvoice.$el.select()
          },
      )
    },
    ClosePopover() {
      setTimeout(() => {
        this.PickupAddressData.popoverShow = false
        this.DestinationAddressData.popoverShow = false
      }, 500)
    },
    ClosePopoverStreet() {
      setTimeout(() => {
        this.PickupAddressData.popover.street.show = false
      }, 500)
    },
    async SearchPickupAddressByName(value) {
      this.PickupAddressData.filteredOptions = []
      this.PickupAddressData.filteredOptions = await this.SearchAddressByName(value)
      this.PickupAddressData.popoverShow = true
    },
    async SearchDestinationAddressByName(value) {
      this.DestinationAddressData.filteredOptions = []
      this.DestinationAddressData.filteredOptions = await this.SearchAddressByName(value)
      this.DestinationAddressData.popoverShow = true
    },
    ClosePopoverCustomerSearch() {
      setTimeout(() => {
        this.CustomerPopover.popover.popoverShow = false
        console.log('CLOSE')
      }, 500)

    },
    async SearchCustomerByName(value) {

      clearTimeout(this.CustomerPopover.popover.timeout)
      this.CustomerPopover.popover.timeout = setTimeout(() => {
        let data = []
        this.$http.get('/customer/list/filter?filter=' + value + '&count=15')
            .then(resp => {
              resp.data.list.forEach(i => {
                data.push(i)
              })
            })
            .catch(err => {
              console.error(err)
            })

        this.CustomerPopover.popover.searchList = data
        this.CustomerPopover.popover.popoverShow = true
      }, 500)

    },
    async SearchAddressByName(value) {
      let rData = []
      this.$http.post('/address', JSON.stringify({
        Value: value,
      }))
          .then(resp => {
            let count = 0
            resp.data.forEach(i => {
              if (count > this.AddressSearchData.autoSuggestLimit) {
                return
              }

              rData.push(i)
              count++
            })
          })
          .catch(err => {
            console.error(err)
          })
      return rData
    },
    SelectAddress(number, type) {
      this.$http.get(`/address/${number}`)
          .then(resp => {
            this.PickupAddressData.popoverShow = false
            this.DestinationAddressData.popoverShow = false
            if (resp.data.success == false) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Info',
                  icon: 'CheckIcon',
                  text: 'Adresse wurde nicht im System gefunden.',
                  variant: 'warning',
                },
              })
            } else {
              let AddressFields = {}
              let ContactFields = {}
              if (type == 'pickup') {
                AddressFields = this.vData.PickUpAddress
                ContactFields = this.vData.PickUpAddressContact
                this.vData.PickUpPassengerNumber = resp.data.AddressId
                this.vData.PickUpPassengerIdentId = resp.data.AddressIdentId

              }
              if (type == 'destination') {
                this.vData.DestinationPassengerNumber = resp.data.AddressId
                this.vData.DestinationPassengerIdentId = resp.data.AddressIdentId
                AddressFields = this.vData.DestinationAddress
                ContactFields = this.vData.DestinationAddressContact
              }

              AddressFields.Street = resp.data.Address.Street
              AddressFields.ZipCode = resp.data.Address.ZipCode
              AddressFields.Location = resp.data.Address.Location
              AddressFields.District = resp.data.Address.District
              ContactFields.Name = resp.data.Contact.Name
              ContactFields.Phone = resp.data.Contact.Phone
              ContactFields.Phone2 = resp.data.Contact.Phone2
              ContactFields.Fax = resp.data.Contact.Fax
              ContactFields.Web = resp.data.Contact.Web
              ContactFields.Email = resp.data.Contact.Email
              if (type == 'pickup') {
                this.$nextTick(() => this.$refs.DestinationPassengerNumber.$el.select())
              } else {
                this.$nextTick(() => this.$refs.TravelDay.$el.select())
              }

            }
          })
          .catch(err => {
            console.error(err)
          })
    },
    checkMobile() {
      console.log(navigator.userAgent)
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
    SelectPickupAddressById(event, typ) {
      if(typ == 2 && !this.checkMobile())
        return

      if (event.keyCode == 13) {
        this.SelectAddress(this.vData.PickUpPassengerNumber, 'pickup')
        localStorage.lastVoucher_PickUpPassengerNumber = this.vData.PickUpPassengerNumber
      }
      if (event.type == 'blur') {
        if (localStorage.lastVoucher_PickUpPassengerNumber == this.vData.PickUpPassengerNumber) {
          return
        }

        this.SelectAddress(this.vData.PickUpPassengerNumber, 'pickup')
        localStorage.lastVoucher_PickUpPassengerNumber = this.vData.PickUpPassengerNumber
      }
      console.log(event)
    },
    SelectPickupAddressByName(row) {
      this.SelectAddress(row.AddressId, 'pickup')
      this.$nextTick(() => this.$refs.TravelDay.$el.select())
    },
    SelectAddressBySearch(row) {
      this.SelectSearchAddress(row)
    },
    SelectDestinationAddressById(event, typ) {
      if(event.type == 'blur' && !this.checkMobile())
        return

      if (event.keyCode == 13) {
        this.SelectAddress(this.vData.DestinationPassengerNumber, 'destination')
        localStorage.lastVoucher_DestinationPassengerNumber = this.vData.DestinationPassengerNumber
      }

      if (event.type == 'blur') {
        if (localStorage.lastVoucher_DestinationPassengerNumber == this.vData.DestinationPassengerNumber) {
          return
        }

        this.SelectAddress(this.vData.DestinationPassengerNumber, 'destination')
        localStorage.lastVoucher_DestinationPassengerNumber = this.vData.DestinationPassengerNumber
      }
    },
    SelectTravelDate(event) {
      if (event.keyCode == 13) {
        this.SelectAddress(this.vData.DestinationPassengerNumber, 'destination')
        this.$nextTick(() => this.$refs.TravelDay.$el.select())
      }
    },
    SelectDestinationAddressByName(row) {
      this.SelectAddress(row.AddressId, 'destination')
      this.$nextTick(() => this.$refs.TravelDay.$el.select())

    },
    SelectCustomerBySearch(row) {
      this.Customer.Number = row.CustomerNumber

      this.LoadCustomer()
    },
    OpenPopover(name) {
      if (name == 'destinationStreet') {
        console.log(name + ' *')
        this.PickupAddressData.popover.street.target = 'DestinationAddressData-Street-popoverShow'
      } else {

        console.log(name + ' #')
        this.PickupAddressData.popover.street.target = 'PickupAddressData-Street-popoverShow'
        this.$nextTick(() => {
          this.PickupAddressData.popover.street.show = true
          clearTimeout(this.PickupAddressData.popover.street.timeout)
          this.PickupAddressData.popover.street.timeout = setTimeout(() => {
            this.SearchAddress(name)
          }, 500)
        })

      }


    },
    SelectSearchAddress(searchString) {
      this.$http.post('/address/place/google', JSON.stringify({
        PlaceId: searchString.PlaceId,
      }))
          .then(resp => {

            if (resp.data.success) {
              if (this.PickupAddressData.popover.street.lastInput == 'pickupStreet') {
                if (this.vData.PickUpAddressContact.Name == '') {
                  let sp = searchString.Address.split(',')
                  this.vData.PickUpAddressContact.Name = sp[0]
                }
                this.vData.PickUpAddress.Street = resp.data.Address.Street
                this.vData.PickUpAddress.ZipCode = resp.data.Address.ZipCode
                this.vData.PickUpAddress.Location = resp.data.Address.Location
                this.vData.PickUpAddress.District = resp.data.Address.District
              }

              if (this.PickupAddressData.popover.street.lastInput == 'destinationStreet') {
                if (this.vData.DestinationAddress.Name == '') {
                  let sp = searchString.Address.split(',')
                  this.vData.DestinationAddressContact.Name = sp[0]
                }
                this.vData.DestinationAddress.Street = resp.data.Address.Street
                this.vData.DestinationAddress.ZipCode = resp.data.Address.ZipCode
                this.vData.DestinationAddress.Location = resp.data.Address.Location
                this.vData.DestinationAddress.District = resp.data.Address.District
              }
              console.log(resp)

              this.$nextTick(() => this.setCaretPosition(this.$refs.PickupAddressStreet.$el, 5))

            }
          })
          .catch(err => {
            console.error(err)
          })
    },
    SearchAddress(type) {
      this.PickupAddressData.popover.street.lastInput = type
      let Zipcode = ''
      let Location = ''
      let Street = ''
      if (type == 'pickupStreet') {
        Zipcode = this.vData.PickUpAddress.ZipCode
        Location = this.vData.PickUpAddress.Location != '' ? this.vData.PickUpAddress.Location + ' ' : ''
        Street = this.vData.PickUpAddress.Street != '' ? this.vData.PickUpAddress.Street + ' ' : ''
      } else {
        Zipcode = this.vData.DestinationAddress.ZipCode != '' ? this.vData.DestinationAddress.ZipCode + ' ' : ''
        Location = this.vData.DestinationAddress.Location != '' ? this.vData.DestinationAddress.Location + ' ' : ''
        Street = this.vData.DestinationAddress.Street != '' ? this.vData.DestinationAddress.Street + ' ' : ''
      }

      this.PickupAddressData.popover.street.searchList = []
      if (Street.length < 5) {
        return
      }
      this.$http.post('/address/search/address', JSON.stringify({
        Zipcode: Zipcode,
        Location: Location,
        Street: Street,
      }))
          .then(resp => {
            if (resp.data.success) {
              resp.data.list.forEach(i => {
                this.PickupAddressData.popover.street.searchList.push(i)
              })
            }
          })
          .catch(err => {
            console.error(err)
          })
    },
    Cancel() {
      this.$swal({
        title: 'STORNIEREN',
        text: 'Möchten Sie diesen Voucher wirklich stornieren?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ja, stornieren!',
        cancelButtonText: 'Nein, abbrechen',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
          .then(result => {
            if (result.isConfirmed) {
              this.$http.post('/voucher/cancel', JSON.stringify(this.vData.Vid))
                  .then(resp => {
                    console.log(resp)
                    if (resp.data.success) {
                      this.LoadVoucher()
                      this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: 'Info',
                          icon: 'CheckIcon',
                          text: 'Voucher wurde storniert.',
                          variant: 'success',
                        },
                      })
                    }
                  })
                  .catch(err => {
                    console.error(err)
                  })
            }
          })
    },

    UndoCancel() {
      this.$http.post('/voucher/undocancel', JSON.stringify(this.vData.Vid))
          .then(resp => {
            if (resp.data.success) {
              this.LoadVoucher()
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Info',
                  icon: 'CheckIcon',
                  text: 'Voucher wurde entstorniert.',
                  variant: 'success',
                },
              })
            }
          })
          .catch(err => {
            console.error(err)
          })
    },
    DeleteVoucher() {
      this.$swal({
        title: 'LÖSCHEN',
        text: 'Möchten Sie diesen Voucher wirklich löschen?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ja, LÖSCHEN!',
        cancelButtonText: 'Nein, abbrechen',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
          .then(result => {
            console.log(result)
            if (result.isConfirmed) {
              this.$http.post('/voucher/delete', JSON.stringify(this.vData.Vid))
                  .then(resp => {
                    if (resp.data.success) {

                      this.$router.push({ name: 'Voucherlist' })
                      this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: 'Speichern',
                          icon: 'CheckIcon',
                          text: 'Voucher wurde gelöscht.',
                          variant: 'warning',
                        },
                      })
                    }
                  })
                  .catch(err => {
                    console.error(err)
                  })
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Abbruch',
                  icon: 'CheckIcon',
                  text: 'Vorgang abgebrochen.',
                  variant: 'warning',
                },
              })
            }
          })
    },
    OpenPdf() {
      if (this.vData.Vid > 0) {
        this.loading.openPdf = true;
        let url = `/voucher/get/pdf/${this.vData.Vid}`
        this.$http.get(url, { responseType: 'blob' })
            .then(resp => {
              console.log(resp);
              if (resp.data.type == 'application/pdf') {
                this.loading.openPdf = false;
                window.open(URL.createObjectURL(resp.data))
              } else {
                setTimeout(() => {
                  this.OpenPdf()
                }, 1000)
              }

            })
            .catch(err => {
              console.error(err)
            })
      }
    },
    OpenPdfInvoice() {
      if (this.vData.Vid > 0 && this.vData.PaymentMethod == 3) {
        let url = `/voucher/get/receipt/pdf/${this.vData.Vid}`
        this.$http.get(url, { responseType: 'blob' })
            .then(resp => {
              if (resp.data.type == 'application/json') {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Info',
                    icon: 'CheckIcon',
                    text: 'Quittung wurde noch nicht geschrieben.',
                    variant: 'warning',
                  },
                })
              }
              if (resp.data.type == 'application/pdf') {
                window.open(URL.createObjectURL(resp.data))
              }

            })
            .catch(err => {
              console.error(err)
            })
      }
    },
    OpenLogs() {
      this.$router.push({
        name: 'VoucherLogList',
        params: { vid: this.$route.params.id }
      })
    },
    async LoadEquipmentList() {
      this.EquipmentList.push(this.Equipment)
      await this.$http.get('equipment/list')
          .then(resp => {
            resp.data.forEach(i => {
              this.EquipmentList.push({
                value: i.Value,
                text: i.Value.Name,
              })
            })

          })
          .catch(err => {
            console.error(err)
          })
    },
    SelectTransportTicket() {
      this.NextInput('TransportTicket')
      if (this.vData.Customer > 0) {

        this.CalculatePrice()
        if (this.vData.MedicalTrip.TransportTicket) {
          this.vData.Price = 0
          this.$refs.EuroFieldPrice.fieldData = 0
          this.CalculateVat()
        }

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Achtung',
            icon: 'CheckIcon',
            text: 'Preis passt sich automatich an.',
            variant: 'warning',
          },
        })
      }
    },
    SelectAdditionalPayment() {
      this.NextInput('AdditionalPayment')
    },
    SelectEquipment() {
      this.EquipmentList.forEach(i => {
        if (i.value.IdentId == this.vData.Equipment) {
          this.$refs.EuroFieldExtraPrice.fieldData = i.value.Price
          this.CalculateVat()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Info',
              icon: 'CheckIcon',
              text: 'Achtung, Preis passt sich automatich an.',
              variant: 'warning',
            },
          })

        }
      })

    },
    SaveAddress(type) {

      let da = {
        'addressIdentId': this.vData.PickUpPassengerIdentId,
        'addressId': this.vData.PickUpPassengerNumber,
        'address': this.vData.PickUpAddress,
        'contact': this.vData.PickUpAddressContact
      }

      if (type == 'destination') {
        da = {
          'addressIdentId': this.vData.DestinationPassengerIdentId,
          'addressId': this.vData.DestinationPassengerNumber,
          'address': this.vData.DestinationAddress,
          'contact': this.vData.DestinationAddressContact
        }
      }
      if (da.addressIdentId == null || da.addressIdentId == 0 || da.addressId == '') {
        if (da.address.Street.length > 0 && da.contact.Name.length > 0) {
          this.$http.post('/address/add', JSON.stringify(da))
              .then(resp => {
                if (resp.data.success) {
                  if (resp.data.infoText != '') {
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Speichern',
                        icon: 'CheckIcon',
                        text: 'Adresse wurde aktualisiert. (' + resp.data.infoText + ').',
                        variant: 'warning',
                      },
                    })
                  } else {
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Speichern',
                        icon: 'CheckIcon',
                        text: 'Adresse wurde aktualisiert.',
                        variant: 'success',
                      },
                    })
                  }
                  console.log(resp.data)
                  if (type == 'destination') {
                    this.vData.DestinationPassengerNumber = resp.data.addressId
                  } else {
                    console.log(this.vData.PickUpPassengerNumber)
                    this.vData.PickUpPassengerNumber = resp.data.addressId
                    console.log(this.vData.PickUpPassengerNumber)
                  }
                }
              })
              .catch(err => {
                console.error(err)
              })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Abbruch',
              icon: 'CheckIcon',
              text: 'Es muss mindestens ein Name und eine Adresse eingegeben werden.',
              variant: 'warning',
            },
          })
        }
      } else {
        this.$swal({
          title: 'Ändern',
          text: 'Möchten sie diese Adresse wirklich ändern?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Ja, ändern!',
          cancelButtonText: 'Nein, abbrechen',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        })
            .then(result => {
              console.log(result)
              if (result.isConfirmed) {
                this.$http.post('/address/save', JSON.stringify(da))
                    .then(resp => {
                      if (resp.data.success) {
                        if (resp.data.infoText != '') {
                          this.$toast({
                            component: ToastificationContent,
                            props: {
                              title: 'Speichern',
                              icon: 'CheckIcon',
                              text: 'Adresse wurde aktualisiert. (' + resp.data.infoText + ').',
                              variant: 'warning',
                            },
                          })
                        } else {
                          this.$toast({
                            component: ToastificationContent,
                            props: {
                              title: 'Speichern',
                              icon: 'CheckIcon',
                              text: 'Adresse wurde aktualisiert..',
                              variant: 'success',
                            },
                          })
                        }
                        if (type == 'destination') {
                          this.vData.DestinationPassengerNumber = resp.data.addressId
                        } else {
                          this.vData.PickUpPassengerNumber = resp.data.addressId
                        }
                      }
                    })
                    .catch(err => {
                      console.error(err)
                    })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Abbruch',
                    icon: 'CheckIcon',
                    text: 'Vorgang abgebrochen.',
                    variant: 'warning',
                  },
                })
              }
            })
      }
    },
    GetPickupNumberState() {
      return 'info'
    },
    GetDestinationNumberState() {
      return 'info'
    },
    RouterBack() {
      this.$router.back()
    },
    GetBlocked() {
      if (this.vData.Vid == 0) {
        return false
      }

      if (this.vData.BillNumber != '') {
        return true
      }

      if (this.vData.Canceled != null) {
        return true
      }

      return false
    },
    SelectInput(ref) {
      if (ref == 'LAST') {
        this.SaveCheck()
      } else if (ref == 'LASTINPUT') {
        this.$nextTick(() => this.$refs[ref].$el.select())
        setTimeout(() => {
          this.hasErrors = false
        }, 500)

      } else {
        if (ref == 'TransportTicket') {
          this.$nextTick(() => this.$refs.TransportTicket.$el.focus())
        } else if (ref == 'CustomerNumber') {
          this.$refs.CustomerNumber.$el.select()
        } else {
          this.$nextTick(() => this.$refs[ref].$el.select())
        }
      }
    },
    async CalculatePrice() {
      let copyData = JSON.parse(JSON.stringify(this.vData))
      const date = copyData.TravelDay.split('.')

      copyData.TravelDay = new Date()
      copyData.TravelDay.setHours( copyData.TravelDay.getHours() + 3);

      await this.$http.post('/voucher/calculatePrice', JSON.stringify({
        'fromId': this.vData.PickUpPassengerIdentId,
        'toId': this.vData.DestinationPassengerIdentId,
        'from': {
          'street': this.vData.PickUpAddress.Street,
          'zipCode': this.vData.PickUpAddress.ZipCode,
          'location': this.vData.PickUpAddress.Location,
          'district': this.vData.PickUpAddress.District
        },
        'to': {
          'street': this.vData.DestinationAddress.Street,
          'zipCode': this.vData.DestinationAddress.ZipCode,
          'location': this.vData.DestinationAddress.Location,
          'district': this.vData.DestinationAddress.District
        },
        'travelDay': copyData.TravelDay

      }))
          .then(resp => {

            console.log(resp)
            this.vData.Price = (resp.data.route.Price + parseFloat(resp.data.route.Enter1)).toFixed(2)
            this.vData.Taxipreis = (resp.data.route.Taxi + parseFloat(resp.data.route.Enter1)).toFixed(2)

            this.vData.Price2 = (resp.data.route.Price + parseFloat(resp.data.route.Enter2)).toFixed(2)
            this.vData.Taxipreis2 = (resp.data.route.Taxi + parseFloat(resp.data.route.Enter2)).toFixed(2)

            this.zoneName = 'Preis: ' + resp.data.route.Name

            this.vData.TripRoute.TripDistanceMeter = resp.data.route.Distance
            this.vData.TripRoute.TripFullDistanceMeter = resp.data.route.TripFullDistanceMeter
            this.vData.TripRoute.TripDuration = resp.data.route.TripDuration
            this.vData.TripRoute.TripFullDuration = resp.data.route.TripFullDuration

          })
          .catch(err => {
            console.error(err)
          })
    },
    CalculateVat() {

      this.vData.Price = this.$refs.EuroFieldPrice.fieldData
      this.vData.PriceExtra = this.$refs.EuroFieldExtraPrice.fieldData
      const price = parseFloat(this.$refs.EuroFieldPrice.fieldData.toString()
          .replace(',', '.')) + parseFloat(this.$refs.EuroFieldExtraPrice.fieldData.toString()
          .replace(',', '.'))

      const identId = this.vData.Customer
      this.$http.post('/voucher/calculateVat', JSON.stringify({
        Price: price,
        CustomerIdentId: identId,
      }))
          .then(resp => {
            if (resp.data.Price > price) {
              this.VatRateLabel = `zzgl. (${resp.data.VarRate}%, ${this.$options.filters.currency(resp.data.VatPrice)})`
              this.EndSum = this.$options.filters.currency((resp.data.VatPrice + price))
            } else {

              this.VatRateLabel = `inkl. (${resp.data.VarRate}%, ${this.$options.filters.currency(resp.data.VatPrice)}`
              this.EndSum = this.$options.filters.currency((price))
            }
          })
          .catch(err => {
            console.error(err)
          })

      this.$refs.EuroFieldPrice.Blur()
      this.$refs.EuroFieldExtraPrice.Blur()

    },
    GetIataData(type) {
      if (type == 'Iata') {
        if (this.vData.Flight.Iata != '') {
          let split = this.vData.TravelDay.split('.')
          this.$http.get(`flightPlan/iata/${this.vData.Flight.Iata}/20${split[2]}-${split[1]}-${split[0]}`)
              .then(resp => {
                if (resp.data.success) {
                  this.vData.Flight.Arrivals = resp.data.flight.Arrivals
                  this.vData.Flight.Departure = resp.data.flight.Departure
                  this.vData.PickupTime = resp.data.flight.PickupTime
                  this.vData.Flight.ScheduledTime = resp.data.flight.ScheduledTime
                  this.NextInput('Iata', '')
                } else {
                  this.NextInput('Iata', 'Arrivals')
                  this.Audio('message-124468.mp3')
                  this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: 'Info',
                          icon: 'CheckIcon',
                          text: `Flugnummer ist dem System nicht beaknnt.`,
                          variant: 'info',
                        },
                      },
                      {
                        timeout: 5000,
                      })
                }

              })
              .catch(err => {
                console.error(err)
              })
        }
      } else {
        if (this.returnTripData.Flight.Iata != '') {
          let splitR = this.returnTripData.TravelDay.split('.')
          this.$http.get(`flightPlan/iata/${this.returnTripData.Flight.Iata}/20${splitR[2]}-${splitR[1]}-${splitR[0]}`)
              .then(resp => {
                if (resp.data.success) {
                  this.returnTripData.Flight.Arrivals = resp.data.flight.Arrivals
                  this.returnTripData.Flight.Departure = resp.data.flight.Departure
                  this.returnTripData.PickupTime = resp.data.flight.PickupTime
                  this.returnTripData.Flight.ScheduledTime = resp.data.flight.ScheduledTime
                  this.NextInput('ReturnIata')
                } else {
                  this.NextInput('ReturnIata', 'ReturnArrivals')
                  this.Audio('message-124468.mp3')
                  this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: 'Info',
                          icon: 'CheckIcon',
                          text: `Flugnummer ist dem System nicht beaknnt.`,
                          variant: 'info',
                        },
                      },
                      {
                        timeout: 5000,
                      })
                }

              })
              .catch(err => {
                console.error(err)
              })
        }
      }
    },
    HasUserDeleteRight() {
      this.R515 = this.$store.state.user.Rights.includes('R515')
    },
    GetPaymentName(id) {
      if (id == 0) {
        return 'Keine Zahlungsart'
      }
      if (id == 1) {
        return 'Rechnung'
      }
      if (id == 2) {
        return 'EC'
      }
      if (id == 3) {
        return 'Barzahlung'
      }
    },
    SendOffer() {

      this.$http.post('/voucher/send/offer', JSON.stringify(this.vData))
          .then(resp => {
            if (resp.data.success) {
              this.$nextTick(() => {
                this.$router.push({ name: 'Voucherlist' })
                this.$nextTick(() => {
                  this.$router.push({ name: 'AddOfferMask' })
                })
              })
              this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Info',
                      icon: 'CheckIcon',
                      text: `Angebot wurde versendet.`,
                      variant: 'success',
                    },
                  },
                  {
                    timeout: 5000,
                  })
            }
          })
          .catch(err => {
            console.error(err)
          })

    },
    async LoadCustomer() {
      if (this.Customer.Number == '') {
        this.Customer.Number = 'BAR'
      }

      localStorage.lastVoucher_CustomerNumber = this.Customer.Number
      await this.$http.get(`/customer/customerNumber/${this.Customer.Number}`)
          .then(resp => {
            this.Customer.IdentId = resp.data.IdentId
            this.Customer.Name = resp.data.Name
            this.vData.Customer = resp.data.IdentId
            this.vData.PaymentMethod = resp.data.PaymentMethod

          })
          .catch(err => {
            console.error(err)
          })
      await this.GetPrice()
    },
    isValidDate: function (d) {
      const date = d.split('.')
      if (date.length != 3) {
        return false
      }
      const day = parseInt(date[0])
      if (day < 0 || day > 31) {
        return false
      }
      const month = parseInt(date[1])
      if (month < 0 || month > 12) {
        return false
      }
      const year = parseInt(date[2])
      if (year > 2021) {
        return false
      }

      return true
    },
    SaveCheck() {
      if ((parseInt(this.vData.Price) + parseInt(this.vData.PriceExtra)) > 999.99) {
        this.$swal({
          title: 'Preis Check',
          text: 'Der Fahrpreis ist über 1.000,00 Euro?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Ja, Speichern!',
          cancelButtonText: 'Nein, abbrechen',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        })
            .then(result => {
              if (result.isConfirmed) {
                this.Save()
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Abbruch',
                    icon: 'CheckIcon',
                    text: 'Vorgang abgebrochen.',
                    variant: 'warning',
                  },
                })
              }
            })
      } else {
        this.Save()
      }
    },
    Save() {
      if (this.loading.base == false) {

        if (this.vData && this.vData.Price) {
          const str = String(this.vData.Price)

          if (str.includes(',')) {
            const newStr = str.replace(',', '.')
            const regex = /([0-9]+,[0-9]+)/g

            // Erhaltung des numerischen Wertes
            const value = this.vData.Price.match(regex)
            if (value) {
              // Ersetzen des Kommas durch einen Punkt
              this.vData.Price = value[0].replace(',', '.')
            }
          } else {
            console.log(str)
            console.log(', object or Price property is missing')
          }
        } else {
          console.log('copyData object or Price property is missing')
        }

        this.loading.base = true
        delete this.vData.Id

        let copyData = JSON.parse(JSON.stringify(this.vData))

        if (!this.isValidDate(copyData.TravelDay)) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Info',
              icon: 'CheckIcon',
              text: 'Datum ist ungültig.',
              variant: 'danger',
            },
          })
          this.loading.base = false
          return
        }
        if (!(copyData.Passengers > 0)) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Info',
              icon: 'CheckIcon',
              text: 'Personenanzahl ist ungültig.',
              variant: 'danger',
            },
          })
          this.loading.base = false
          return
        }
        if (!(copyData.Customer > 0)) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Info',
              icon: 'CheckIcon',
              text: 'Rechnungskunde ist ungültig.',
              variant: 'danger',
            },
          })
          this.loading.base = false
          return
        }
        if (this.vData.PickupTime.length != 5) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Info',
              icon: 'CheckIcon',
              text: 'Pickupzeit ist ungültig (' + this.vData.PickupTime + ' (' + this.vData.PickupTime.length + ')).',
              variant: 'danger',
            },
          })
          this.loading.base = false
          return
        }
        localStorage.lastVoucher = JSON.stringify(this.vData)
        const date = copyData.TravelDay.split('.')
        copyData.TravelDay = new Date('20' + date[2] + '-' + date[1] + '-' + date[0])
        let copyDataReturn = null
        if (this.returnTripData.Passengers > 0) {
          if (this.returnTripData.PickupTime.length != 5) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Info',
                icon: 'CheckIcon',
                text: 'Pickupzeit ist ungültig.(' + this.returnTripData.PickupTime + ' (' + this.returnTripData.PickupTime.length + '))',
                variant: 'danger',
              },
            })
            this.loading.base = false
            return
          }
          copyDataReturn = JSON.parse(JSON.stringify(this.vData))
          const returnDate = this.returnTripData.TravelDay.split('.')
          copyDataReturn.TravelDay = new Date('20' + returnDate[2] + '-' + returnDate[1] + '-' + returnDate[0])

          let PickUpAddress = this.vData.PickUpAddress
          let PickUpAddressContact = this.vData.PickUpAddressContact
          let PickUpPassengerIdentId = this.vData.PickUpPassengerIdentId
          let PickUpPassengerNumber = this.vData.PickUpPassengerNumber
          let DestinationAddress = this.vData.DestinationAddress
          let DestinationAddressContact = this.vData.DestinationAddressContact
          let DestinationPassengerIdentId = this.vData.DestinationPassengerIdentId
          let DestinationPassengerNumber = this.vData.DestinationPassengerNumber

          copyDataReturn.PickUpAddress = DestinationAddress
          copyDataReturn.PickUpAddressContact = DestinationAddressContact
          copyDataReturn.PickUpPassengerIdentId = DestinationPassengerIdentId
          copyDataReturn.PickUpPassengerNumber = DestinationPassengerNumber

          copyDataReturn.DestinationAddress = PickUpAddress
          copyDataReturn.DestinationAddressContact = PickUpAddressContact
          copyDataReturn.DestinationPassengerIdentId = PickUpPassengerIdentId
          copyDataReturn.DestinationPassengerNumber = PickUpPassengerNumber

          copyDataReturn.Passengers = this.returnTripData.Passengers
          copyDataReturn.PassengersChildren = this.returnTripData.PassengersChildren
          copyDataReturn.MedicalTrip = this.returnTripData.MedicalTrip
          copyDataReturn.Flight = this.returnTripData.Flight
          copyDataReturn.PickupTime = this.returnTripData.PickupTime
          copyDataReturn.Description1 = this.returnTripData.Description1
          copyDataReturn.Description2 = this.returnTripData.Description2
          copyDataReturn.DescriptionPdf = this.returnTripData.DescriptionPdf

        }

        this.$http.post('/voucher/set', JSON.stringify(copyData))
            .then(resp => {
              if (resp.data.success) {
                if (copyDataReturn != null) {
                  copyDataReturn.ConnectedVoucherId = resp.data.newVid
                  this.$http.post('/voucher/set', JSON.stringify(copyDataReturn))
                      .then(resp => {
                        if (resp.data.success) {
                          this.$toast({
                                component: ToastificationContent,
                                props: {
                                  title: 'Info',
                                  icon: 'CheckIcon',
                                  text: `Voucher (${resp.data.newVid} und ${copyDataReturn.ConnectedVoucherId}) wurde gespeichert.`,
                                  variant: 'success',
                                },
                              },
                              {
                                timeout: 10000,
                              })
                          this.loading.base = false
                          this.$router.back()
                        }
                      })
                      .catch(err => {
                        this.loading.base = false
                        console.error(err)
                      })
                } else {
                  this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: 'Info',
                          icon: 'CheckIcon',
                          text: `Voucher (${resp.data.newVid}) wurde gespeichert.`,
                          variant: 'success',
                        },
                      },
                      {
                        timeout: 10000,
                      })
                  this.loading.base = false
                  this.$router.back()
                }
              }
            })
            .catch(err => {
              this.loading.base = false
              console.error(err)
            })
      }
    },
    UpdateMarker() {
      this.VehicleMarkers.forEach((aData, index) => {
        let found = false
        this.Maps.Pickup.markers.forEach((mData, index2) => {
          if (mData.id == aData.id) {
            this.Maps.Pickup.markers[index2].position = aData.position
            found = true
          }
        })

        if (!found) {
          this.Maps.Pickup.markers.push(aData)
        }
      })

    },

    async LoadVoucher() {
      this.FormatTravelDay()
      if (this.$route.params.id > 0) {
        await this.$http.get(`/voucher/get/${this.$route.params.id}`)
            .then(resp => {
              if (resp.data.success == undefined) {
                let d = new Date(resp.data.TravelDay)
                let ye = new Intl.DateTimeFormat('de', { year: '2-digit' }).format(d)
                let mo = new Intl.DateTimeFormat('de', { month: '2-digit' }).format(d)
                let da = new Intl.DateTimeFormat('de', { day: '2-digit' }).format(d)
                resp.data.TravelDay = da + '.' + mo + '.' + ye

                if (resp.data.DestinationAddress.Coordinates != null) {
                  const marker = {
                    lat: resp.data.DestinationAddress.Coordinates.lat,
                    lng: resp.data.DestinationAddress.Coordinates.lng,
                  }
                  this.Maps.Pickup.markers.push({ position: marker })
                }
                if (resp.data.PickUpAddress.Coordinates != null) {
                  const marker = {
                    lat: resp.data.PickUpAddress.Coordinates.lat,
                    lng: resp.data.PickUpAddress.Coordinates.lng,
                  }
                  this.Maps.Pickup.markers.push({ position: marker })
                }
                this.UpdateMarker()
                if (resp.data.Flight == null) {
                  resp.data.Flight = {
                    Iata: '',
                    Departure: '',
                    Arrivals: '',
                    ScheduledTime: '00:00',
                    ExpectedTime: '00:00'
                  }
                }
                if (resp.data.MedicalTrip == null) {
                  resp.data.MedicalTrip = {
                    TransportTicket: null,
                    AdditionalPayment: null,
                    AppointmentTime: '',
                  }
                }

                this.vData = resp.data
                this.$refs.EuroFieldPrice.fieldData = this.vData.Price
                this.$refs.EuroFieldExtraPrice.fieldData = this.vData.PriceExtra
                this.$refs.EuroFieldPrice.Blur()
                this.$refs.EuroFieldExtraPrice.Blur()
              } else {
                this.RouterBack()
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Fehler',
                    icon: 'CheckIcon',
                    text: resp.data.message,
                    variant: 'danger',
                  },
                })
              }

            })
            .catch(err => {
              console.error(err)
            })

        if (!this.vData.Customer) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'warning',
              icon: 'CheckIcon',
              text: 'Voucher hat keinen Rechnungskunde.',
              variant: 'warning',
            },
          })
          this.vData.Customer = 0
        } else {
          await this.$http.get(`/customer/customerId/${this.vData.Customer}`)
              .then(resp => {
                console.log(resp)
                console.log(this.vData.Customer)
                this.Customer.Name = resp.data.Name
                this.Customer.Number = resp.data.CustomerNumber
                this.Customer.IdentId = this.vData.Customer
              })
              .catch(err => {
                console.error(err)
              })
        }
        await this.CalculateVat()
        this.FormatTravelDay()
        this.ChangeRideType(this.vData.RideType)
      }
      if (this.$route.params.id == 0) {

        await this.$http.get(`/voucher/get/tempVoucherId`)
            .then(resp => {
              if (resp.data.success) {
                this.tempId = resp.data.vId
              }
            })
            .catch(err => {
              console.error(err)
            })
        if (!this.$route.params.type) {
          this.ChangeRideType(0)
        } else {
          this.ChangeRideType(this.$route.params.type)
        }
      }
    }
  }
}
</script>

<style scoped>
.popover {
  max-width: 100%; /* Max Width of the popover (depending on the container!) */
}

.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>

<style lang="scss">
.vue2leaflet-map {
  &.leaflet-container {
    height: 350px;
  }
}
</style>
